import { cva } from 'class-variance-authority';

const sharedVariants = {
    isFocusVisible: {
        true: 'tw-outline tw-outline-1 tw-outline-success',
        false: ''
    }
};

export const tableClassNames = cva(
    'tw-border-collapse tw-flex-1 tw-border-solid tw-border-accents-2 tw-border-1 tw-overflow-hidden tw-rounded-xl tw-table-fixed tw-border-spacing-0 tw-w-full',
    {
        variants: {
            hoverable: {
                true: ''
            },
            isMultiple: {
                true: ''
            }
        }
    }
);

export const tableContainerClassNames = cva(
    'tw-flex tw-flex-col tw-rounded-xl tw-overflow-x-auto tw-overflow-y-hidden',
    {
        variants: {
            shadow: {
                true: {
                    bs: '$md'
                }
            },
            bordered: {
                true: {
                    borderStyle: 'solid',
                    borderColor: '$border'
                },
                false: {
                    bw: 0
                }
            },

            borderWeight: {
                light: {
                    bw: '$light'
                },
                normal: {
                    bw: '$normal'
                },
                bold: {
                    bw: '$bold'
                },
                extrabold: {
                    bw: '$extrabold'
                },
                black: {
                    bw: '$black'
                }
            }
        },
        defaultVariants: {
            shadow: true,
            borderWeight: 'normal'
        }
    }
);

export const loadingRowClassNames = cva('tw-w-full tw-flex tw-items-center tw-justify-center', {
    variants: {
        isAtEnd: {
            true: 'tw-h-16',
            false: 'tw-h-[calc(100%-2.75rem)]'
        },
        isAbsolute: {
            true: 'tw-absolute tw-left-0 tw-top-6'
        }
    }
});

export const tableRowClassNames = cva(
    'tw-overflow-visible tw-text-accents-9 tw-border-solid tw-border-0 tw-border-t tw-border-accents-0 first:tw-border-t-0',
    {
        variants: {
            hoverable: {
                true: 'hover:aria-[selected=false]:tw-bg-accents-0 tw-transition-colors *:tw-cursor-pointer'
            },
            isDisabled: {
                true: 'tw-text-accents-3 tw-pointer-events-none tw-cursor-not-allowed'
            },
            isSelected: {
                true: 'tw-text-accents-9 tw-bg-successLight/50'
            },
            isInfinityScroll: {
                true: 'tw-table tw-table-fixed tw-w-full'
            },
            ...sharedVariants
        }
    }
);

export const tableCellClassNames = cva(
    'tw-relative tw-select-none tw-cursor-default tw-py-2.5 tw-pr-2.5 tw-z-20 tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis first:tw-pl-4 last:tw-pr-4 before:-tw-z-10 before:tw-content-[""] before:tw-absolute before:tw-size-full before:tw-top-0 before:tw-left-0 before:tw-opacity-0', // tw-translate-z-0 tw-backface-hidden
    {
        variants: {
            isSelected: {
                true: 'tw-text-accents-9 before:tw-opacity-100 tw-bg-successLight/20'
            },
            align: {
                start: 'tw-text-left',
                center: 'tw-text-center',
                end: 'tw-text-right'
            },
            isStatic: {
                true: 'tw-cursor-text tw-select-text'
            },
            ...sharedVariants
        }
    }
);

export const rowGroupClassNames = cva('', {
    variants: {
        isFixed: {
            true: 'tw-table tw-w-full tw-table-fixed'
        },
        isInfinityScroll: {
            true: 'tw-block tw-h-full tw-overflow-auto tw-pb-6'
        }
    },
    defaultVariants: {
        isInfinityScroll: false
    }
});

export const columnHeaderClassNames = cva(
    'tw-h-10 tw-p-0 tw-px-2 tw-bg-accents-2 tw-text-accents-7 tw-text-xs tw-relative first:tw-pl-4 first:tw-rounded-tl-lg last:tw-pr-4 last:tw-rounded-tr-lg',
    {
        variants: {
            align: {
                start: 'tw-text-left',
                center: 'tw-text-center',
                end: 'tw-text-right'
            },
            allowsSorting: {
                true: 'tw-cursor-pointer hover:tw-text-accents-8 hover:tw-bg-accents-1',
                false: 'tw-cursor-default'
            },
            isSorted: {
                false: 'tw-text-success hover:tw-text-success'
            },
            ...sharedVariants
        },
        defaultVariants: {
            align: 'start',
            allowsSorting: false
        }
    }
);

// const FilterButtonContainer = styled('div', {
//     position: 'absolute',
//     bottom: 0,
//     top: 0,
//     zIndex: '$5',
//     display: 'flex',
//     gap: '$4',
//     alignItems: 'center',
//     justifyContent: 'center',
//     variants: {
//         align: {
//             start: { marginRight: 10, right: 0 },
//             center: { marginRight: 10, right: 0 },
//             end: { marginLeft: 10, left: 0 }
//         }
//     },
//     defaultVariants: {
//         align: 'start'
//     }
// });
